// 外部サイトへのリンクを別タブで開く設定
const links = document.querySelectorAll('.list-menu a');
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
    links[i].classList.add('link_blank');
  }
}
